import React, { FC } from 'react';
import styled from 'styled-components';
import { SubPageModel } from '../../common/model/ui/sub-page.model';
import { Navigate, Route, Routes } from 'react-router-dom';
import breakpoints from '../../design-system/breakpoints';
import Variables from '../../design-system/variables';
import OvMobileNav from '../UI/organisms/OvMobileNav';
import OvSideNav from '../UI/organisms/OvSideNav';
import OvScrollToTop from '../../common/utils/components/OvScrollToTop';

const PageContentTemplate: FC<{ subPages: SubPageModel[] }> = ({
  subPages,
  ...props
}) => {
  const navigationPages = subPages
    .filter((page) => page.isVisible && (page.linkLabel || page.linkIcon))
    .reverse();

  return (
    <Container {...props}>
      <OvSideNav subPages={navigationPages} />

      <ContentWrapper>
        <>
          <OvScrollToTop />
          <Routes>
            {subPages
              .filter((page) => page.isVisible)
              .map((page) =>
                page.redirectUrl ? (
                  <Route
                    key={`${page.url}:${page.redirectUrl}`}
                    path={page.url}
                    element={<Navigate to={`/${page.redirectUrl}`} replace />}
                  />
                ) : (
                  <Route
                    key={page.url}
                    path={page.url ? `${page.url}/*` : ''}
                    element={page.component}
                  />
                )
              )}
          </Routes>
        </>
      </ContentWrapper>
      <OvMobileNav subPages={navigationPages} />
    </Container>
  );
};

export default PageContentTemplate;

const Container = styled.section`
  padding: 0.5rem;
  position: relative;
  z-index: 1;
  top: 68px;

  margin: 0 auto;

  @media (max-width: ${breakpoints.lg}) {
    padding-bottom: ${Variables.layout.MOBILE_NAV_HEIGHT};
  }

  @media (min-width: ${breakpoints.lg}) {
    padding: 1rem 0.5rem;
    display: flex;
    align-items: flex-start;
  }
`;

const ContentWrapper = styled.section`
  flex-grow: 1;
  min-width: 18.75rem;

  /* iOS Safari widens the layout viewport for any overflowing page, which pushes
     the fixed bottom nav off screen, so wide legacy pages scroll in here instead.
     The negative margin keeps card shadows from being clipped. A scroll container
     would capture page-level sticky elements, so pages with one opt out. */
  @media (max-width: ${breakpoints.lg}) {
    &:not(:has([data-viewport-sticky])) {
      overflow-x: auto;
      margin: 0 -0.5rem;
      padding: 0 0.5rem 0.5rem;
    }

    && > * {
      margin-left: 0;
    }
  }
`;
